module.exports = __webpack_public_path__ + "static/fonts/iconfont.a512655.ttf";